import useBoard from "@/hooks/useBoard";
import { Hexagon } from "@/ui/Hexagon";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import { TeamMemberImage } from "@/ui/TeamMemberImage";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import bg_4 from "./bg_4.webp";
import bg_5 from "./bg_5.webp";
import classes from "./styles.module.scss";
import Vector from "./Vector.svg";

export default function ({
  className = "pt-5 py-md-6",
  title,
  description,
  image,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  const members = useBoard();

  return (
    <div className={cn(className, classes.OurBoard)} data-bs-theme={theme}>
      <Container className="mw-lg mb-4 mb-md-5">
        <Row>
          <Col xs={12} className="text-center">
            <EditableText path="title" tag="h2" className="mb-3">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
            <EditableHtml path="description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
          </Col>
        </Row>
      </Container>
      <div className="position-relative">
        <ParallaxBackground anim="y1n:x0:z1" image={bg_1} className={classes.bg_1} />
        <ParallaxBackground
          anim="y1:x2:z0"
          image={bg_2}
          floating={false}
          className={classes.bg_2}
        />
        <ParallaxBackground anim="y2:x0:z0" image={bg_3} className={classes.bg_3} />
        <ParallaxBackground anim="y1:x2:z0" image={bg_4} className={classes.bg_4} />
        <ParallaxBackground
          anim="y2:x0:z0"
          image={bg_5}
          floating={false}
          className={classes.bg_5}
        />
        <Container fluid="md">
          <img src={Vector} alt="" className={cn(classes.vector, "d-none d-md-block")} />
          <div className={cn(classes.img, "d-none d-md-block")}>
            <Hexagon>
              <EditableImage path="image" src={image} size="299x232" alt="" />
            </Hexagon>
          </div>
          {members.map(({ name, tagline, description, image }, idx) => (
            <Row
              key={idx}
              className={cn("py-md-6", {
                "flex-row": idx % 2 === 0,
                "flex-row-reverse": idx % 2 !== 0,
                "text-white": idx === 1,
              })}
            >
              <Col xs={12} md={6}>
                <div
                  className={cn("mb-5 mb-md-0", {
                    "pe-md-7": idx % 2 === 0,
                    "ps-md-5": idx % 2 !== 0,
                  })}
                >
                  <Tagline>{tagline}</Tagline>
                  <h3 className="mb-4">{name}</h3>
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </Col>
              <Col xs={12} md={6}>
                <Parallax translateY={[0, -20]}>
                  <TeamMemberImage
                    className={cn(classes.member__img, "m-auto", {
                      "ms-md-auto": idx % 2 === 0,
                      "me-md-auto": idx % 2 !== 0,
                    })}
                    src={image}
                    alt={name}
                    hoverable={false}
                  />
                </Parallax>
              </Col>
            </Row>
          ))}
        </Container>
      </div>
    </div>
  );
}
